import {useState, createContext, useEffect} from 'react';
import axios from './axios'

export const UserContext = createContext();

export const UserProvider = props => {
	const [user, setUser] = useState({});
	const [sucursal, setSucursal] = useState('');
	const [auth, setAuth] = useState(true);
	const [pedidos,setPedidos] = useState(true);


	useEffect(()=>{
		axios.get('/api/user')
		.then(res => {
			if(res.status === 200 && res.data && res.data.id){ 
				setUser(res.data);
				/*fetchPedidos(res.data.id);*/
				const tempSucursal = localStorage.getItem("sucursal_name") ||
					(Array.isArray(res.data.sucursals) && res.data.sucursals.length > 0 ? res.data.sucursals[0].nombre_sucursal : '');
				setSucursal(tempSucursal);
				if (!localStorage.getItem("sucursal_name")) {
					localStorage.setItem('sucursal_name', tempSucursal);
				}
			} else {
				setAuth(false);
			}
		}).catch(e => console.error(e))
	},[]);

	const fetchPedidos = (userID) => {
		let pedidosTemp = [];

		axios.post('/api/user_orders',{user_id:userID})
		.then(resp => {
			console.log("response pedidos",resp);
			if(resp.status === 200){
				pedidosTemp = resp.data.map((item)=>{
					return {
						estatus:item.estatus,
						id:item.id,
						step:item.step
					}
				});
				console.log("pedidosTemp",pedidosTemp);
				setPedidos(pedidosTemp);
			} 
		}).catch(e => console.error(e))
	}

	return (
		<UserContext.Provider value={{user,setUser,auth,setAuth,sucursal,setSucursal,pedidos}}>
			{props.children}
		</UserContext.Provider>
	)
}
